<template>
  <codemirror
    ref="editor"
    :value="fromValue(value)"
    :options="{
      mode: language,
      lineNumbers: true,
      autoRefresh: true,
      readOnly: disabled,
      // lineWrapping: true,
    }"
    class="form-control"
    :class="{ disabled: disabled }"
    :state="error ? 'invalid' : null"
    @input="$emit('input', fromValue(arguments[0]))" />
    <!--
    :placeholder="label"
    -->
</template>
<script>
import FormFieldMixin from 'vue-forms/mixins/FormFieldMixin';
import CodeFieldMixin from 'vue-forms/mixins/CodeFieldMixin';

import { codemirror } from 'vue-codemirror'

// require styles
import 'codemirror/lib/codemirror.css'

import 'codemirror/mode/javascript/javascript'
import 'codemirror/mode/xml/xml'
import 'codemirror/addon/display/autorefresh'

export default {
  mixins: [ FormFieldMixin, CodeFieldMixin ],

  components: {
    codemirror
  },

  beforeMount() {
    this.widgets = [];
  },

  mounted() {
    this.setErrors();
  },

  beforeUpdate() {
    this.removeLineWidgets();
  },

  updated() {
    this.setErrors();
  },

  beforeDestroy() {
    this.removeLineWidgets();
  },

  methods: {
    removeLineWidgets() {
      const editor = this.$refs.editor.codemirror;
      if (this.widgets) {
        for (let i = 0; i < this.widgets.length; i++) {
          editor.removeLineWidget(this.widgets[i]);
        }
      }
      this.widgets = [];
    },

    errorsFromError() {
      if (!this.error) {
        return [];
      }

      const match = this.error.match(/^.*Line (\d+), column \d+: (.+)$/);
      if (match) {
        return [
          {
            line: match[1],
            message: match[2],
          }
        ];
      }

      return [];
    },

    setErrors() {
      const editor = this.$refs.editor.codemirror;
      const errors = this.errorsFromError();
      if (errors) {
        for (let i = 0; i < errors.length; i++) {
          const error     = errors[i];
          const errorLine = error['line'] - 1;
          console.log('Found error at line', errorLine, ':', error);
          const msg = document.createElement("div");
          msg.appendChild(document.createTextNode(error.message));
          msg.className = "bg-danger";
          this.widgets.push(
            editor.addLineWidget(errorLine, msg, { coverGutter: false })
          );
        }
      }
    }
  }
};
</script>
<style>
.CodeMirror {
  height: auto;
}

.vue-codemirror.form-control {
  padding: 0;
  height: auto;
}

.vue-codemirror.form-control.disabled .CodeMirror {
  background-color: #e4e7ea !important;
}
</style>
